import React, { useState } from "react";
import { Row, Col, Button } from "antd";
import TimeFromMidnightItem from "../../../components/forms/TimeFromMidnightItem";
import SwitchItem from "../../../components/forms/SwitchItem";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import MonthAndBranchesModal from "../../../components/templates/MonthAndBranchesModal";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import FormHeader from "../../../components/forms/FormHeader";
import { InputItem } from "../../../components/forms/FormItems";
import { exportPatients } from "../../patients/PatientsSlice";
import { openURL } from "../../../components/util/helpers";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
const PatientsExport = (props) => {
  const { changedItems, changedValues, activeOrganization } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const [exportPatientsVisible, setExportPatientsVisible] = useState(false);
  const exportLoading = useSelector(
    (state) => state.pendingActions["patients/export"]
  );
  const isActive = changedItems.includes("patients_export.active")
    ? changedValues["patients_export.active"]
    : activeOrganization["patients_export"] &&
      activeOrganization["patients_export"].active;
  const onExport = async (values) => {
    const data = {
      branchId: null,
      params: {
        year: +moment(values.month).format("YYYY"),
        month: +moment(values.month).format("M"),
        branch_ids: values.all_branches ? null : values.branches,
        incremental: values.incremental,
      },
    };
    const action = await dispatch(exportPatients(data));
    if (!action.error) {
      hidePatientsExport();
      openURL(action.payload.data.file_url);
    }
  };
  const handlePatientExport = () => {
    setExportPatientsVisible(true);
  };

  const hidePatientsExport = () => {
    setExportPatientsVisible(false);
  };

  const AdditionalItems = () => (
    <AnimationChildWrapper itemKey={3}>
      <CheckBoxItem showLabel={true} name="incremental" category="component" />
    </AnimationChildWrapper>
  );
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.organization.patientsExport" />}
          comp={
            <SwitchItem
              name="patients_export.active"
              category="organization"
              hideLabel={true}
              noStyle={true}
            />
          }
        />
        {isActive && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="patients_export.ftp_user"
                    category="organization"
                    required={true}
                    direction={"ltr"}
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="patients_export.ftp_password"
                    category="organization"
                    password={true}
                    required={true}
                    direction={"ltr"}
                  />
                </div>
              </ResponsiveItemsWrapper>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="patients_export.ftp_address"
                    category="organization"
                    required={true}
                    domainOrIp={true}
                    direction={"ltr"}
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="patients_export.output_dir"
                    category="organization"
                    required={true}
                    direction={"ltr"}
                  />
                </div>
              </ResponsiveItemsWrapper>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <TimeFromMidnightItem
                    name="patients_export.daily_sync_time"
                    category="organization"
                    picker="time"
                    format={"HH:mm"}
                    minuteStep={30}
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="patients_export.dir_per_branch"
                    category="organization"
                  />
                </div>
              </ResponsiveItemsWrapper>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <Button
                    type="primary"
                    onClick={handlePatientExport}
                    size="large"
                  >
                    {intl.formatMessage({
                      id: "app.patients.export_patients",
                    })}
                  </Button>
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}></div>
              </ResponsiveItemsWrapper>
            </Col>
          </Row>
        )}
      </Surface>
      <MonthAndBranchesModal
        onHide={hidePatientsExport}
        visible={exportPatientsVisible}
        title={intl.formatMessage({
          id: "app.patients.export_patients",
        })}
        btnText={intl.formatMessage({
          id: "app.actions.export",
        })}
        initialValues={{
          month: moment(),
          branches: [],
        }}
        onSubmit={onExport}
        branchId={null}
        loading={exportLoading}
        additionaItems={<AdditionalItems />}
      />
    </div>
  );
};

export default PatientsExport;
